import { gql, useMutation } from '@apollo/client'
import { Modal2 } from 'components/Modal'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/TextInput'
import { Form, Formik } from 'formik'
import { useToast } from './Toast'
import { CancelOrderMutation, CancelOrderMutationVariables } from './__generated__/CancelOrderMutation'

const cancelOrderMutation = gql`
  mutation CancelOrderMutation($input: CancelOrderInput!) {
    cancelOrder(input: $input) {
      success
      message
      order {
        id
        status
      }
    }
  }
`

interface CancelOrderModalProps {
  orderId: string
  onRequestClose: () => void
}
const CancelOrderModal = ({ orderId, onRequestClose }: CancelOrderModalProps) => {
  const [cancelOrder] = useMutation<CancelOrderMutation, CancelOrderMutationVariables>(cancelOrderMutation)

  const { addToast } = useToast()

  return (
    <Modal2 isOpen onRequestClose={onRequestClose} header="Cancel Order">
      <Formik
        initialValues={{ zdRef: '', reason: '' }}
        onSubmit={async (values, { setStatus }) => {
          try {
            const resp = await cancelOrder({
              variables: {
                input: {
                  orderId,
                  reason: values.reason,
                  zdRef: values.zdRef,
                },
              },
            })

            if (!resp.data.cancelOrder.success) {
              throw new Error(resp.data.cancelOrder.message || 'Something went wrong')
            }

            onRequestClose()
            addToast({
              messageType: 'success',
              title: 'Canceled',
              content: <>Order canceled</>,
              timeout: 5000,
            })
          } catch (err) {
            setStatus({ error: err.message })
          }
        }}
      >
        {({ isSubmitting, status }) => (
          <Form>
            <TextInput name="reason" label="Cancelation reason" />
            <TextInput name="zdRef" label="Zendesk ticket no (if applicable)" />
            <article className="message is-warning">
              <div className="message-body">
                This will remove the order from the batch only. You still need to refund the Stripe payment separately.
              </div>
            </article>
            <div className="buttons is-right mt-5">
              <SubmitButton className="is-primary" submitting={isSubmitting} disabled={isSubmitting}>
                Cancel Order
              </SubmitButton>
            </div>
            {status?.error && (
              <article className="message is-danger">
                <div className="message-body">Failed: {status.error}</div>
              </article>
            )}
          </Form>
        )}
      </Formik>
    </Modal2>
  )
}

export default CancelOrderModal
